import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

export default function LinearProgressBar({ value, color }: LinearProgressProps) {
  return (
    <Box display="flex" alignItems="center" paddingBottom="10px">
      {!value ? (
        <Box width="100%">
          <LinearProgress variant="indeterminate" color={color} />
        </Box>
      ) : (
        <>
          <Box width="100%">
            <LinearProgress variant="determinate" value={value} color={color} />
          </Box>
          <Box minWidth="35px">
            <Typography variant="body2" color="secondary">
              {`${Math.round(
                value,
              )}%`}

            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
